module.exports = __webpack_public_path__ + "static/img/ent-detail-56.a301944.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-56.jpg
// module id = +NWP
// module chunks = 52